const SHOW_MODAL = '@@modals/SHOW_MODAL';

const CLOSE_MODAL = '@@modals/CLOSE_MODAL';

export { SHOW_MODAL, CLOSE_MODAL };
